<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData" :custom-create-actions="[listFuenteMacro]"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedFuenteConcreta" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"  :custom-update-actions="[listFuenteMacro]"
                    :custom-update-collection-data="customUpdateCollectionData" @updateValues="setupUpdateValues"
                    :updatePermission="'updates_fuentes_macro'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedFuenteConcreta"
                           :load-data="loadDataFuenteConcreta" :entity="entity" :auth-token="authToken"
                           :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataFuenteConcreta"
                 :collection-fuente-macro = "collectionFuenteMacro"
                 :custom-update-value-data="customUpdateValueData" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {copiaProfunda} from "@/common/constants";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import FuentesConcretasCrearActualizarComponent
  from "@/components/parametros/components/FuentesConcretasCrearActualizarComponent";
import {listCollectionData, useLayoutMain} from "@/layouts/main";

export default {
  name: 'FuentesConcretasCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    FuentesConcretasCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Fuentes concretas',
      entity: {gender: 'f', value: 'fuente concreta'},
      childFormComponent: 'FuentesConcretasCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'codigo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Código",
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre",
        },
        'fuenteMacro.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Fuente Macro",
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionFuenteMacro = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedFuenteConcreta = ref({
      id: '',
      codigo: '',
      nombre: '',
      id_fuente_macro:'',
      estado: ''
    });
    const loadDataFuenteConcreta = ref({
      codigo: '',
      nombre: '',
      id_fuente_macro:''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_FUENTECONCRETA_CREATE,
      list: process.env.VUE_APP_NEST_FUENTECONCRETA_FINDALL,
      update: process.env.VUE_APP_NEST_FUENTECONCRETA_UPDATE,
      updateState: process.env.VUE_APP_NEST_FUENTECONCRETA_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      return value;
    };
    const customUpdateCollectionData = () => {
      return copiaProfunda(collectionData.value);
    };

    const listFuenteMacro = async () => await listCollectionData(process.env.VUE_APP_NEST_FUENTEMACRO_FINDALL, {'collectionFuenteMacro': collectionFuenteMacro}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedFuenteConcreta, loadDataFuenteConcreta, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedFuenteConcreta,
      loadDataFuenteConcreta,
      listApi,
      paginate,
      queries,
      collectionFuenteMacro,
      setupUpdateValues,
      cleanLoadSelectedData,
      listFuenteMacro,
      customUpdateCollectionData,
      customUpdateValueData,
    };
  }
}
</script>